module.exports = __webpack_public_path__ + "img/pencil-create-new.adbfd256.svg";